/** "1 image" / "3 images" — shared so the wording can't drift between screens. */
export function pluralize(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? "" : "s"}`;
}
